// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1717":"dc765f9f","3247":"bc99209f","4022":"bc99209f","5653":"90cf00cc"}[chunkId] + ".chunk.css";
};